module.exports = __webpack_public_path__ + "img/imagen-web.b52b9712.png";